<template>
  <section>
    <v-dialog
      v-model="showModal"
      max-width="700px"
    >
      <v-card
        shaped
        color="#ECEFF1"
      >
        <br>
        <h2 class="modal-title-style">
          <v-icon class="modal-icon-style">
            mdi-account-question-outline
          </v-icon> Reason
        </h2>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                >
                  <p
                    class="my-p-style"
                  >
                    <font>
                      Please provide a reason for requesting a manual check-out.
                    </font>
                  </p>
                  <v-text-field
                    v-model="manualCheckoutReason"
                    outlined
                    light
                    filled
                    color="#000000"
                    label="Reason*"
                    dense
                  />
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  class="mt-2"
                  color="#37474F"
                  @click="showModal = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  class="mt-2"
                  color="#FF3700"
                  @click="confirm()"
                >
                  Confirm
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
    </v-dialog>
  </section>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';

export default {
  name: 'ManualCheckoutReason',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      showModal: true,
      loading: false,
      manualCheckoutReason: '',
    };
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    confirm () {
      if (this.manualCheckoutReason === '') {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please provide a reason.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.$store.dispatch('swiftuser/saveManualCheckoutReason', this.manualCheckoutReason);
      this.$store.dispatch('swiftuser/saveCheckoutType', 'manual');
      this.$emit('manual-checkout');
    },
  },
};
</script>
<style scoped>
.my-p-style {
  font-size: 18px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.modal-title-style {
  color: #37474F;
  margin-left: 30px;
}
.modal-icon-style {
  color: #37474F;
  font-size: 45px;
}
</style>
